export * from './delete-projekt.component';
export * from './delete-projekt.component.module';